import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { linearModel } from 'mobx-store';

import { SCATTER_PLOT_TYPES } from 'mobx-store/linearModel';

import ScatterPlot from 'components/ScatterPlot';

import { withHeader } from '../ScatterPlotHeader';

const ScatterPlotComponent = observer(
  class ScatterPlotComponent extends React.Component {
    static propTypes = {
      type: PropTypes.oneOf([
        SCATTER_PLOT_TYPES.MAIN,
        SCATTER_PLOT_TYPES.NORMAL,
        SCATTER_PLOT_TYPES.RESIDUALS
      ]).isRequired,

      showRegressionLine: PropTypes.bool.isRequired,
      showConfidenceIntervals: PropTypes.bool.isRequired
    }

    get isMainScatterPlot () {
      return this.props.type === SCATTER_PLOT_TYPES.MAIN;
    }

    get isNormalScatterPlot () {
      return this.props.type === SCATTER_PLOT_TYPES.NORMAL;
    }

    get yAxisLabel () {
      return this.isMainScatterPlot
        ? linearModel.secondaryParameter.name
        : 'Residual';
    }

    get xAxisLabel () {
      return this.isNormalScatterPlot
        ? 'z Percentile'
        : linearModel.primaryParameter.name;
    }

    get dots () {
      let dots = linearModel.residualsScatterPlotDots;
      if (this.isNormalScatterPlot) {
        dots = linearModel.probabilityPlot;
      }
      if (this.isMainScatterPlot) {
        dots = linearModel.mainScatterPlotDots;
      }
      return dots;
    }

    get confidenceIntervalDots () {
      return this.isMainScatterPlot && this.props.showConfidenceIntervals
        ? linearModel.confidenceIntervalDots
        : null;
    }

    render () {
      return (
        <ScatterPlot
          dots={this.dots}
          yAxisLabel={this.yAxisLabel}
          xAxisLabel={this.xAxisLabel}
          confidenceIntervalDots={this.confidenceIntervalDots}
          showRegressionLine={this.props.showRegressionLine}
        />
      );
    }
  }
);

export default withHeader(ScatterPlotComponent);
